// Mock data for Fenicis Global Hospitality

export const heroImages = {
  main: "https://customer-assets.emergentagent.com/job_4784fb3a-af82-47af-8481-64e4c88e7aeb/artifacts/hn6yl3ql_WhatsApp%20Image%202026-01-29%20at%2016.45.23.jpeg", // Nidale with mirrors - Hero
  secondary: "https://images.unsplash.com/photo-1764060835377-e630c00ae5eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxQb250JTIwQWxleGFuZHJlJTIwSUlJJTIwUGFyaXMlMjBnb2xkZW4lMjBicmlkZ2UlMjBlbGVnYW50fGVufDB8fHx8MTc2OTc2NjE0NXww&ixlib=rb-4.1.0&q=85", // Pont Alexandre III - House of Fenicis (Paris heritage)
  tertiary: "https://customer-assets.emergentagent.com/job_4784fb3a-af82-47af-8481-64e4c88e7aeb/artifacts/62tpmw9r_WhatsApp%20Image%202026-01-29%20at%2019.36.32.jpeg", // Hotel lobby
  lebanese: "https://images.unsplash.com/photo-1571134737208-54344f058d44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxMZWJhbm9uJTIwQmVpcnV0JTIwbHV4dXJ5JTIwYXJjaGl0ZWN0dXJlJTIwZWxlZ2FudCUyMGhlcml0YWdlfGVufDB8fHx8MTc2OTc2NjE1NHww&ixlib=rb-4.1.0&q=85" // Downtown Beirut heritage architecture
};

export const servicesImage = "https://customer-assets.emergentagent.com/job_4784fb3a-af82-47af-8481-64e4c88e7aeb/artifacts/62tpmw9r_WhatsApp%20Image%202026-01-29%20at%2019.36.32.jpeg"; // Nidale in luxury hotel lobby

// Contemporary color images for modern feel
export const contemporaryImages = {
  hotelCorridor: "https://images.unsplash.com/photo-1768396747960-ae6ba3c855bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBob3RlbCUyMGFyY2hpdGVjdHVyZSUyMGludGVyaW9yJTIwbGlnaHQlMjBjb250ZW1wb3Jhcnl8ZW58MHx8fHwxNzcyNDcyMTc4fDA&ixlib=rb-4.1.0&q=85",
  modernLobby: "https://images.unsplash.com/photo-1767395523555-c44546bea0f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBob3RlbCUyMGFyY2hpdGVjdHVyZSUyMGludGVyaW9yJTIwbGlnaHQlMjBjb250ZW1wb3Jhcnl8ZW58MHx8fHwxNzcyNDcyMTc4fDA&ixlib=rb-4.1.0&q=85",
  minimalistStaircase: "https://images.unsplash.com/photo-1758548157440-a5640f99b5cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtaW5pbWFsaXN0JTIwYXJjaGl0ZWN0dXJlJTIwbWFyYmxlJTIwbGlnaHQlMjBlbGVnYW50fGVufDB8fHx8MTc3MjQ3MjE4NXww&ixlib=rb-4.1.0&q=85"
};

export const founderImage = "https://customer-assets.emergentagent.com/job_fenicis-hospitality/artifacts/cfy28pz0_Pro%20Pic.jpg";

export const pillars = [
  {
    id: 1,
    title: "Art in Hospitality",
    description: "We believe hospitality is an art form. Every detail, every interaction, every moment is intentional—designed to create experiences that are not just seen, but deeply felt."
  },
  {
    id: 2,
    title: "Transformation & Renewal",
    description: "Great hospitality transforms. Our approach goes beyond service to create journeys that leave guests feeling renewed, inspired, and profoundly connected to place and purpose."
  },
  {
    id: 3,
    title: "Emotional Resonance",
    description: "The essence of Fenicis lies in creating experiences that resonate on a deeper level. It's not what guests see—it's what they feel. Authentic connection is our compass."
  }
];

export const engagements = [
  {
    id: 1,
    title: "Parisian Heritage Reimagined",
    category: "Brand Strategy & Positioning",
    description: "Elevating a historic Parisian property for the next generation of global travelers.",
    image: "https://images.unsplash.com/photo-1720934016001-b057ebfd293d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZXNvcnQlMjBkZXN0aW5hdGlvbiUyMGVsZWdhbnQlMjBzb3BoaXN0aWNhdGVkJTIwaW5zcGlyYXRpb25hbHxlbnwwfHx8fDE3NzAwNDY2NzB8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Luxury Hospitality Excellence",
    category: "Boutique Hotels & Advisory",
    description: "Transforming guest experiences through refined service and operational distinction.",
    image: "https://images.unsplash.com/photo-1625244724120-1fd1d34d00f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxmaXZlJTIwc3RhciUyMGhvdGVsJTIwbG9iYnklMjBzb3BoaXN0aWNhdGVkJTIwZWxlZ2FudCUyMGx1eHVyaW91cyUyMGludGVyaW9yfGVufDB8fHx8MTc3MDA0NjY4M3ww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Event & Hospitality Management",
    category: "Luxury Maisons & Corporate Excellence",
    description: "Orchestrating exceptional events for high-end luxury maisons and corporate entities—from intimate board meetings to international gatherings—while also operating as white label for distinguished travel and event companies worldwide.",
    image: "https://images.unsplash.com/photo-1769773297747-bd00e31b33aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwcHJpdmF0ZSUyMGRpbmluZyUyMGx1eHVyeSUyMGV2ZW50JTIwc29waGlzdGljYXRlZHxlbnwwfHx8fDE3NzAwNDU0MDJ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Private Journey Design",
    category: "UHNW Travel & Experiences",
    description: "Curating transformative travel moments for discerning global citizens.",
    image: "https://images.unsplash.com/photo-1587542249430-4be0cc60a659?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjByZXNvcnQlMjBkZXN0aW5hdGlvbiUyMGVsZWdhbnQlMjBzb3BoaXN0aWNhdGVkJTIwaW5zcGlyYXRpb25hbHxlbnwwfHx8fDE3NzAwNDY2NzB8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const services = [
  {
    id: 1,
    title: "Boutique Hotels & Hospitality Advisory",
    description: "Strategic guidance for luxury properties seeking distinction. We transform boutique hotels and hospitality groups through refined positioning, elevated guest experiences, and market expansion strategies.",
    details: [
      "Strategic repositioning and brand evolution",
      "Market expansion and growth strategies",
      "Clienteling programs and guest relationship management",
      "Guest experience transformation and operational excellence"
    ]
  },
  {
    id: 2,
    title: "UHNW Travel & Private Journeys",
    description: "Ultra-bespoke travel experiences for the world's most discerning individuals. Every journey is crafted with absolute discretion, privileged access, and profound attention to personal preferences.",
    details: [
      "Cultural immersions with exclusive access",
      "Transformative wellness retreats",
      "Multi-generational family journeys",
      "Global itineraries with discreet luxury service"
    ]
  },
  {
    id: 3,
    title: "Brand Experiences & Executive Activations",
    description: "Immersive brand activations that create lasting impressions. We design exceptional experiences for global brands, executive leadership, and institutional partners seeking meaningful engagement.",
    details: [
      "Immersive brand activations for luxury houses",
      "Executive retreats and leadership gatherings",
      "Investor programs and stakeholder experiences",
      "Cultural collaborations and artistic partnerships"
    ]
  },
  {
    id: 4,
    title: "International Partnerships & Network Delivery",
    description: "Leverage our global ecosystem of palaces, DMCs, cultural institutions, and elite partners. White-label solutions for MICE agencies, corporate programs, and international hospitality networks.",
    details: [
      "White-label luxury travel programs",
      "MICE and corporate event solutions",
      "Access to palace hotels and iconic properties",
      "Global network of cultural institutions and elite partners"
    ]
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "Italian Fashion Excellence Meets Roman Grandeur",
    subtitle: "High-End Fashion Brand Event, Rome",
    challenge: "A prestigious Italian fashion maison required flawless hospitality management for an exclusive international buy-out event at Hôtel de Crillon—demanding seamless coordination, cultural sensitivity, and impeccable execution for global VIPs.",
    approach: "Full-spectrum hospitality orchestration from arrival experiences to culinary excellence, ensuring every touchpoint reflected the brand's heritage and sophistication. Our team managed hotel operations, guest relations, and logistical precision throughout the multi-day event.",
    outcome: "Delivered a transformative brand experience praised by international media and attendees. Zero operational issues across 72 hours of intensive programming. Client relationship continues with ongoing collaborations.",
    image: "https://images.unsplash.com/photo-1622616235385-2aa666eb79d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2aWxsYSUyMHJlc29ydCUyMHBvb2wlMjBtZWRpdGVycmFuZWFuJTIwZWxlZ2FudCUyMGV4Y2x1c2l2ZXxlbnwwfHx8fDE3NzAwNDgxOTd8MA&ixlib=rb-4.1.0&q=85",
    category: "Event & Hospitality Management"
  },
  {
    id: 2,
    title: "Diplomatic Excellence in Alpine Setting",
    subtitle: "International Summit, Switzerland",
    challenge: "A governmental entity required comprehensive hospitality management for high-level diplomats and officials at an international summit—balancing protocol requirements, security considerations, and luxury service standards.",
    approach: "Designed and executed a white-glove hospitality program encompassing accommodations, dining experiences, ground transportation, and cultural programming. Maintained absolute discretion while delivering world-class service to distinguished international delegates.",
    outcome: "Flawless execution recognized by organizing authorities. All protocol requirements met with precision. Established Fenicis Global Hospitality as trusted partner for governmental and institutional events of significance.",
    image: null,
    category: "Governmental & Institutional Relations"
  },
  {
    id: 3,
    title: "Multigenerational Journey Across Continents",
    subtitle: "UHNW Family Travel, Middle East to Europe",
    challenge: "A distinguished Middle Eastern family sought a transformative multi-generational travel experience spanning multiple countries—requiring cultural depth, educational enrichment, and seamless logistics for three generations traveling together.",
    approach: "Curated bespoke itinerary combining private museum access, Michelin-starred dining, wellness programming, and meaningful cultural exchanges. Coordinated private aviation, accommodation at historic properties, and personalized experiences honoring family values and interests.",
    outcome: "Family expressed profound gratitude for experiences that strengthened bonds and created lasting memories. Subsequent referrals to family office network. Relationship continues with annual travel planning partnership.",
    image: null,
    category: "UHNW Travel & Private Journeys"
  },
  {
    id: 4,
    title: "Luxury Real Estate & Members Club Expansion",
    subtitle: "Property Group Partnership Development",
    challenge: "A high-end luxury property group and members club required strategic partnership development and sales acceleration in competitive European markets—needing refined market positioning and access to UHNW networks.",
    approach: "Leveraged our extensive network within luxury hospitality and family office communities. Created targeted introduction strategy, facilitated key partnerships, and provided strategic counsel on market positioning and membership cultivation.",
    outcome: "Significant partnership agreements secured. Enhanced brand recognition within target demographic. Ongoing advisory relationship for international expansion and membership development initiatives.",
    image: null,
    category: "Strategic Partnerships & Development"
  }
];

export const founderData = {
  name: "Nidale Barret",
  title: "Founder",
  image: founderImage,
  philosophy: "The essence of Fenicis lies in creating experiences that resonate on a deeper level. It's not what guests see—it's what they feel.",
  bio: "Born from a profound belief that hospitality is an art form, Fenicis embodies the unique intersection of Parisian savoir-faire and heartfelt human connection.\n\nMy journey through the world's most distinguished establishments—from the legendary halls of the Ritz Paris, Four Seasons, Mandarin Oriental, and Hôtel de Crillon, A Rosewood Hotel, to the creative universe of Christian Dior Couture, and the international gateway of Aéroports de Paris—has shaped a unique perspective on luxury hospitality.\n\nWhat I learned is this: true distinction lies not in what we offer, but in how we make people feel. Every journey, every encounter, every detail is an opportunity to create something transformative. This philosophy is the beating heart of Fenicis.",
  credentials: [
    "Former Leadership Roles: Ritz Paris, Four Seasons, Mandarin Oriental, Hôtel de Crillon (A Rosewood Hotel)",
    "Fashion & Luxury Marketing: Christian Dior Couture",
    "International Protocol & Guest Relations: Aéroports de Paris",
    "Academic Lecturer in Luxury Hospitality Management"
  ]
};

export const teamMembers = [
  {
    id: 1,
    name: "Nidale Barret",
    title: "Founder",
    image: founderImage,
    bio: "Born from a profound belief that hospitality is an art form, Fenicis embodies the unique intersection of Parisian savoir-faire and heartfelt human connection. My journey through the world's most distinguished establishments—from the Ritz Paris, Four Seasons, Mandarin Oriental, and Hôtel de Crillon, to Christian Dior Couture and Aéroports de Paris—has shaped a unique perspective on luxury hospitality."
  },
  {
    id: 2,
    name: "Camille Carron",
    title: "Business Director",
    image: "https://customer-assets.emergentagent.com/job_fenicis-hospitality/artifacts/p9mitnpx_Photo%20Camille%20focus.jpeg",
    bio: "Camille Carron joins Fenicis Global Hospitality as Business Director, bringing 10+ years of experience across luxury hospitality, bespoke events, and high-impact business development. She has led MICE Event Sales at Airelles (LOV Group) across six destinations, driving revenue growth and managing key accounts with a strong multi-site mindset. Earlier, at Hôtel de Crillon, A Rosewood Hotel, she delivered premium corporate and private events—from executive seminars to high-profile brand activations—combining commercial rigor with flawless operational execution. More recently, at PRADA Group (France/Monaco/Belgium), she managed high-volume regional events with demanding stakeholders and tight timelines. Known for her discretion, client-first mindset, and attention to detail, Camille pairs strategic vision with hands-on leadership and rigorous budget control—strengthening Fenicis' ability to scale with excellence and precision."
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Nidale understood what we couldn't articulate. Her guidance transformed our maison's trajectory while honoring everything we hold dear.",
    author: "C-Level Advisor, Luxury Sector",
    location: "Paris"
  },
  {
    id: 2,
    quote: "Rare combination of strategic intelligence and genuine cultural fluency. Fenicis opened doors we didn't know existed.",
    author: "Family Office Principal",
    location: "Dubai"
  },
  {
    id: 3,
    quote: "Not consultants in the traditional sense. True partners who invest in understanding before advising. Exceptional.",
    author: "Luxury Group CEO",
    location: "Paris"
  }
];

// Mock scheduler data
export const availableTimeSlots = [
  { date: "2025-01-15", slots: ["10:00", "14:00", "16:00"] },
  { date: "2025-01-16", slots: ["11:00", "15:00"] },
  { date: "2025-01-17", slots: ["09:00", "13:00", "17:00"] }
];
